import {
  dashboardIcon,
  dataScienceIcon,
} from 'common/layouts/AuthLayout/Icons';

// Import the better icon functions
import {
  accountManagementIcon,
  jobsManagementIcon,
  orgGoalsIcon,
  repositoryManagementIcon,
  organzationIcon,
  teamProjectsIcon,
  systemSetupIcon,
  interventionsIcon,
} from './SettingsIcons';

import { SidebarNavItem } from 'common/types/SidebarNavItem';
import { activityLogIcon, categoriesIcon } from './SettingsIcons';

export const SettingsNavData = [
  {
    id: 'organization-management',
    link: '/settings/admin/organization',
    title: 'Organizations',
    fr: 'organisation managériale',
    svg: organzationIcon,
    section_title: 'Management',
    superuser: true,
    staff: true,
  },

  {
    id: 'accounts',
    link: '/settings/admin/accounts',
    title: 'Accounts',
    fr: 'Gestion des comptes',
    svg: accountManagementIcon,
    superuser: true,
    staff: true,
  },

  {
    id: 'activity-log',
    link: '/settings/admin/activity-log',
    title: 'Activity Log',
    fr: "Journal d'activité",
    svg: activityLogIcon,
    superuser: true,
    staff: false,
  },

  {
    id: 'foundations',
    link: '/settings/admin/recommendation-templates/foundations',
    title: 'Foundations',
    svg: dataScienceIcon,
    section_title: 'Action Plans',
    superuser: true,
    staff: true,
  },
  {
    id: 'organization-goals',
    link: '/settings/admin/recommendation-templates/org-goals',
    title: 'Organizational Goals',
    svg: orgGoalsIcon,
    superuser: true,
    staff: true,
  },

/* TP: This feature is deprecated for the moment, until we figure out what to do with it 
If we get rid of it, remove from routes. */

  /* {
    id: 'team-recommendations',
    link: '/settings/admin/recommendation-templates/team-recs',
    title: 'Team Projects',
    svg: teamProjectsIcon,
    superuser: true,
    staff: true,
  }, */
  {
    id: 'interventions',
    link: '/settings/admin/recommendation-templates/interventions',
    title: 'Focus Areas',
    svg: interventionsIcon,
    superuser: true,
    staff: true,
  },

  // Survey Structure subsection under Action Plans
  {
    id: 'survey-questions',
    link: '/settings/admin/survey-questions',
    title: 'Questions',
    fr: 'Questions',
    svg: dataScienceIcon,
    section_title: 'Survey Structure',
    superuser: true,
    staff: true,
  },
  {
    id: 'categories',
    link: '/settings/admin/categories',
    title: 'Categories',
    fr: 'catégories',
    svg: categoriesIcon,
    superuser: true,
    staff: true,
  },
  {
    id: 'pulse-surveys',
    link: '/settings/admin/pulse-surveys',
    title: 'Pulse Questions',
    fr: 'Sondages pulse',
    svg: dataScienceIcon,
    superuser: true,
    staff: true,
    feature_flag: 'Pulse Surveys',
  },

  {
    id: 'provenance-queue',
    link: '/settings/admin/provenance-queue',
    title: 'Provenance Review',
    fr: 'Révision de provenance',
    svg: repositoryManagementIcon,
    superuser: true,
    staff: true,
    feature_flag: 'Knowledge Repository Ingestion Pipeline',
  },
  {
    id: 'repository-management',
    link: '/settings/admin/repository-management',
    title: 'Repository Files',
    fr: 'Gestion du référentiel',
    section_title: 'Advanced Settings',
    svg: repositoryManagementIcon,
    superuser: true,
    staff: true,
  },
  {
    id: 'system-health',
    link: '/settings/admin/system-health',
    title: 'System Health',
    fr: 'Santé du système',
    svg: jobsManagementIcon,
     superuser: true,
    staff: false,
  },


  {
    id: 'system-setup',
    link: '/settings/admin/system-setup',
    title: 'System Setup',
    fr: 'Configuration système',
    svg: systemSetupIcon,
    superuser: true,
    staff: false,
  },

  {
    id: 'portal',
    link: '/app/dashboard',
    title: 'Return to Portal',
    svg: dashboardIcon,
    section_title: 'Portal',
    superuser: true,
    staff: true,
  },
] as SidebarNavItem[];

export default SettingsNavData;
